// Generated by scripts/content-build.mjs. Do not edit.
// Source of truth is content/about.yaml.

/** First professional role, used to derive years in the field. */
export const CAREER_START_YEAR = 2014

/** A run of prose that may contain inline links. */
export type Segment = string | { text: string; href: string }

export const profile = {
  name: 'Blake Mulnix',
  role: 'Software Consultant',
  tagline: 'I build software and the teams that build it.',
  cardTagline:
    'I help teams ship faster by getting them to slow down for ten minutes.',
  location: 'Iowa',
} as const

export const aboutParagraphs: Segment[][] = [
  [
    "Hey, I'm Blake. I'm a consultant at ",
    { text: 'Source Allies', href: 'https://www.sourceallies.com' },
    ", where I work with a crew that's unreasonably good at delivering software. We do as much coaching as coding, helping teams and organizations pick up new skills and see for themselves why the practices we live by are worth keeping.",
  ],
]
